<div class="company-item-container">
  <div *ngIf="!errorMessage; else elseBlock">
    <form novalidate [formGroup]="companyForm">
      <mat-card>
        <mat-card-content>

          <!-- Header: existing company -->
          <div class="card-header" *ngIf="isNewCompany()">
            <span class="card-title">Contact</span>
            <span class="spacer"></span>
            <button *ngIf="!_authService.readOnly" mat-icon-button
                    (click)="openModal()"
                    matTooltip="delete" matTooltipPosition="below">
              <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="!_authService.readOnly" mat-icon-button
                    [disabled]="!(companyForm.valid && companyForm.dirty)"
                    (click)="saveCompany()"
                    matTooltip="save" matTooltipPosition="below">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button
                    [routerLink]="['/addressbook']"
                    matTooltip="close" matTooltipPosition="below">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Header: new company -->
          <div class="card-header" *ngIf="!isNewCompany()">
            <span class="card-title">New Contact</span>
          </div>

          <!-- Company fields -->
          <div class="company-fields">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label><span class="mandatory-marker">* </span>Company Name</mat-label>
              <input matInput formControlName="name" type="text">
              <mat-error *ngIf="displayMessage.name">{{ displayMessage.name }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Company Notes</mat-label>
              <textarea matInput formControlName="notes" maxlength="255"></textarea>
              <mat-error *ngIf="displayMessage.notes">{{ displayMessage.notes }}</mat-error>
            </mat-form-field>
          </div>

          <!-- Contacts -->
          <div class="contacts-section" formArrayName="contacts">
            <div [formGroupName]="i" *ngFor="let contact of contacts.controls; let i=index">
              <company-contact
                [currentItem]="currentCompanyContact"
                [group]="contact"
                [count]="contacts.length"
                [current]="i"
                (addItem)="addCompanyContact()"
                (removeItem)="removeCompanyContact(i)"
                (selectedItem)="CompanyContactSelected($event)">
              </company-contact>
            </div>
          </div>

        </mat-card-content>

        <mat-card-actions class="detail-card-actions" align="end">
          <a mat-button class="detail-footer-cancel" [routerLink]="['/addressbook']">
            {{ companyForm.dirty ? 'Cancel' : 'Close' }}
          </a>
          <button *ngIf="!_authService.readOnly"
                  type="button"
                  mat-button
                  class="detail-footer-save"
                  (click)="saveCompany()"
                  [disabled]="!(companyForm.valid && companyForm.dirty)">
            {{ SaveLabel }}
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>

<ng-template #elseBlock>
  <div class="error-message">{{ errorMessage }}</div>
</ng-template>
